import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
};

/**
 * Spinner component for loading states with animated rotation and dynamic color.
 * Use for indicating loading or processing states in buttons and content areas.
 *
 * @example
 * ```tsx
 * <CustomSpinner className="h-6 w-6" color="#000000" />
 * ```
 */
export const CustomSpinner: FC<Props> = ({
  color = "currentColor",
  ...props
}) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_20754_12140)">
      <rect
        x="11.0605"
        width="2"
        height="6"
        rx="1"
        fill={color}
        opacity="0.6"
      />
      <rect
        x="11.0605"
        y="18"
        width="2"
        height="6"
        rx="1"
        fill={color}
        opacity="0.2"
      />
      <rect
        x="0.0625"
        y="12.9999"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-90 0.0625 12.9999)"
        fill={color}
        opacity="0.6"
      />
      <rect
        x="18.0625"
        y="12.9999"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-90 18.0625 12.9999)"
        fill={color}
        opacity="0.6"
      />
      <rect
        x="2.86914"
        y="4.22186"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-45 2.86914 4.22186)"
        fill={color}
        opacity="0.6"
      />
      <rect
        x="15.5957"
        y="16.9497"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-45 15.5957 16.9497)"
        fill={color}
        opacity="0.3"
      />
      <rect
        x="17.0137"
        y="8.46442"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-135 17.0137 8.46442)"
        fill={color}
        opacity="0.6"
      />
      <rect
        x="4.28418"
        y="21.1924"
        width="2"
        height="6"
        rx="1"
        transform="rotate(-135 4.28418 21.1924)"
        fill={color}
        opacity="0.05"
      />
    </g>
    <defs>
      <clipPath id="clip0_20754_12140">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.0625)"
        />
      </clipPath>
    </defs>
  </svg>
);
